export default "__VITE_ASSET__y5Iv$Ln$__"